import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
interface Testimonial {
  initials: string;
  name: string;
  location: string;
  text: string;
  color: string;
  pack?: string;
}
interface TestimonialsProps {
  testimonials: Testimonial[];
  title?: string;
  className?: string;
}
export function Testimonials({
  testimonials,
  title,
  className = ''
}: TestimonialsProps) {
  return <section className={`py-16 bg-slate-50 ${className}`} data-id="element-313">
      <div className="container mx-auto px-4" data-id="element-314">
        {title && <h2 className="text-3xl font-bold text-center mb-12 text-slate-900" data-id="element-315">
            {title}
          </h2>}

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-6xl mx-auto" data-id="element-316">
          {testimonials.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: i * 0.1
        }} className="bg-white p-6 rounded-2xl shadow-sm border border-slate-100 flex flex-col h-full" data-id="element-317">
              <div className="flex items-center gap-1 mb-4" data-id="element-318">
                {[...Array(5)].map((_, j) => <Star key={j} className="w-4 h-4 text-amber-400 fill-amber-400" data-id="element-319" />)}
              </div>

              <p className="text-slate-700 italic mb-6 flex-grow" data-id="element-320">"{t.text}"</p>

              <div className="flex items-center gap-3 mt-auto pt-4 border-t border-slate-50" data-id="element-321">
                <div className={`w-10 h-10 rounded-full flex items-center justify-center text-white font-bold text-sm ${t.color}`} data-id="element-322">
                  {t.initials}
                </div>
                <div data-id="element-323">
                  <p className="font-bold text-slate-900 text-sm" data-id="element-324">{t.name}</p>
                  <p className="text-xs text-slate-500" data-id="element-325">{t.location}</p>
                  {t.pack && <p className="text-xs font-medium text-blue-600 mt-0.5" data-id="element-326">
                      {t.pack}
                    </p>}
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}
export const initialTestimonials = [{
  initials: 'MG',
  name: 'María G.',
  location: 'Córdoba',
  text: 'Nunca pensé que iba a poder hablarle a mi vecino sordo. En dos semanas ya nos saludamos y charlamos básico. Increíble.',
  color: 'bg-purple-500'
}, {
  initials: 'LP',
  name: 'Laura P.',
  location: 'Rosario',
  text: 'Mi hija tiene una compañera sorda y este material me permitió acompañarla de verdad. Vale cada peso.',
  color: 'bg-pink-500'
}, {
  initials: 'RM',
  name: 'Roberto M.',
  location: 'Buenos Aires',
  text: 'Trabajo en una farmacia y entró un cliente sordo. Por primera vez pude atenderlo sin papel y lapicera. Se emocionó. Yo también.',
  color: 'bg-blue-500'
}];
export const moreTestimonials = [{
  initials: 'CR',
  name: 'Cecilia R.',
  location: '🏙️ Mendoza',
  pack: 'MegaPack + Profesional',
  text: 'Soy enfermera y por fin puedo preguntarle a mis pacientes sordos dónde les duele y qué tipo de dolor es. El módulo de salud cambió mi práctica para siempre.',
  color: 'bg-emerald-500'
}, {
  initials: 'RM',
  name: 'Roberto M.',
  location: '🏙️ Buenos Aires',
  pack: 'MegaPack LSA Listo',
  text: 'Mi hermano es sordo y nunca habíamos tenido una conversación real. Hoy le conté cómo fue mi semana en señas. Lloramos los dos.',
  color: 'bg-blue-500'
}, {
  initials: 'SC',
  name: 'Sofía C.',
  location: '🏙️ La Plata',
  pack: 'MegaPack LSA Listo',
  text: 'Soy docente y tengo un alumno sordo integrado. Antes dependía del intérprete para todo. Ahora puedo darle la consigna del examen yo misma. Él me mira diferente.',
  color: 'bg-amber-500'
}, {
  initials: 'PA',
  name: 'Pablo A.',
  location: '🏙️ Neuquén',
  pack: 'MegaPack + Profesional',
  text: 'Trabajo en un estudio jurídico. El módulo legal me dio el vocabulario para explicarle sus derechos a un cliente sordo sin que pierda ni un solo detalle.',
  color: 'bg-slate-700'
}];